module.exports = __webpack_public_path__ + "static/media/loupe-dark.2f6d9829.svg";